import type { Swiper } from 'swiper/types';
import { CustomElement } from '@/utils';

export default class Gallery extends CustomElement {
  static component = 'b-gallery';

  swiper: Swiper | null = null;
  swiperSecondary: Swiper | null = null;
  swiperEl: HTMLDivElement | null = null;
  swiperElSecondary: HTMLDivElement | null = null;
  nextEl: HTMLDivElement | null = null;
  prevEl: HTMLDivElement | null = null;
  caption: HTMLDivElement | null = null;
  paginationEl: HTMLDivElement | null = null;
  secondaryColor: HTMLDivElement | null = null;
  nextUrl = '';
  prevUrl = '';
  loop = false;
  once = false;
  autoWidth = false;
  qty = 1;
  perView = 1;
  startIndex = 0;
  name = '';

  init() {
    this.name = this.getAttribute('name') || '';
    this.loop = this.getAttribute('loop') === '';
    this.autoWidth = this.getAttribute('auto-width') === '';
    this.nextUrl = this.getAttribute('next-url');
    this.prevUrl = this.getAttribute('prev-url');
    this.startIndex = Number(this.getAttribute('start-index') || 0);
    this.swiperEl = this.$<HTMLDivElement>('main');
    this.swiperElSecondary = this.$<HTMLDivElement>('secondary');
    this.nextEl = this.$<HTMLDivElement>('next');
    this.prevEl = this.$<HTMLDivElement>('prev');
    this.caption = this.$<HTMLDivElement>('caption');
    this.secondaryColor = this.$<HTMLDivElement>('secondary-color');
    this.paginationEl = document.querySelector('[data-el="pagination"]');
    this.qty = this.swiperEl?.querySelectorAll('.swiper-slide').length || 1;
    this.perView = Number(this.getAttribute('per-view') || 1);
    this.caption = this.$<HTMLDivElement>('caption');
    if (!this.caption) {
      this.caption = document.querySelector(`[data-swiper-caption="${this.name}"]`);
    }

    if (this.getAttribute('disabled') !== null) {
      return;
    }

    import('@/utils/swiper').then((module) => {
      if (!module) return;

      const { Swiper: Sw, modules } = module;
      const slides = this.swiperEl ? Array.from(this.swiperEl.querySelectorAll('.swiper-slide')) : [];

      if (slides.length < 2) {
        return;
      }


      if (this.swiperElSecondary) {
        this.swiperSecondary = new Sw(this.swiperElSecondary, {
          modules,
          effect: 'fade',
          speed: 1000,
          fadeEffect: {
            crossFade: true,
          },
          on: {
            slideChange: (swiper) => {
              const slide = swiper.slides[swiper.activeIndex];
              if (slide && this.secondaryColor) {
                if (slide.hasAttribute('data-theme-secondary')) {
                  this.secondaryColor.style.backgroundColor = slide.getAttribute('data-theme-secondary');
                } else {
                  this.secondaryColor.style.backgroundColor = '';
                }
              }
            }
          }
        });
      }

      this.swiper = new Sw(this.swiperEl, {
        modules,
        speed: 1000,
        loop: this.loop,
        slidesPerView: this.autoWidth ? 'auto' : (this.perView > 3 ? 2 : this.perView),
        spaceBetween: this.autoWidth ? 60 : 0,
        initialSlide: this.startIndex,
        grabCursor: true,
        preventInteractionOnTransition: true,
        navigation: { nextEl: this.nextEl, prevEl: this.prevEl },
        breakpoints: {
          768: {
            slidesPerView: this.autoWidth ? 'auto' : this.perView,
          }
        },
        thumbs: {
          swiper: this.swiperSecondary,
        },
        pagination: this.paginationEl ? {
          el: this.paginationEl,
          type: 'fraction',
          renderFraction:  (currentClass, totalClass) => {
            return `<span class="${currentClass}"></span> of <span class="${totalClass}"></span>`;
          }
        } : false,
        on: {
          init: (swiper) => {
          },
          slideChange: (swiper) => {
            const slide = swiper.slides[swiper.realIndex];
            if (this.caption) {
              this.caption.innerHTML = slide.getAttribute('data-slide-caption') ?? '';
            }
          },
        },
      });
    });
  }

  destroyed() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
